import { useQuery } from "@tanstack/react-query"
import { getAllProjects } from "../../../api/projects/getAllProjects"

export const useGetAllProjects = (page: number = 1, limit: number = 10) => {
  return useQuery({
    queryKey: ['allProjects', page, limit],
    queryFn: () => getAllProjects(page, limit),
    staleTime: 1000 * 60 * 20, // datos considerados frescos por 20 minutos
    gcTime: 1000 * 60 * 30, // datos permanecen en caché por 30 minutos
    refetchOnMount: true, // revalidar al montar el componente
    refetchOnWindowFocus: false, // no revalidar al enfocar la ventana
  })
}
